import { P0, S, abs, arc, core, disc, frac, moodK } from '../../geometry';

export const ripples = {
  name: 'Ripples',
  colors: ['#3E63DD', '#8E4EC6'],
  draw(m, t) {
    let emit = 0,
      sp = 0.6,
      span = 70,
      pose = P0();
    if (m === 'happy') {
      emit = 1;
      sp = 1.3;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: rings keep spreading out to both sides.
    if (m === 'thinking') {
      emit = 1;
      sp = 0.6;
    }
    if (m === 'talking') {
      emit = 1;
      sp = 1.5;
    }
    if (m === 'surprised') span = 90;
    const strokes = [];
    for (const side of [0, 180])
      for (let k = 0; k < 3; k++) {
        let r, o;
        if (emit) {
          const f = frac(t * sp + k / 3);
          r = 21 + f * 20;
          o = S(Math.PI * f);
        } else if (m === 'surprised') {
          r = 26 + k * 8;
          o = 1 - k * 0.2;
        } else if (m === 'paused') {
          r = 22 + k * 6;
          o = k ? 0 : 0.6;
        } else {
          r = 23 + k * 7 + 0.6 * S(t * 1.6);
          o = 1 - k * 0.25;
        }
        strokes.push({
          c: k === 1 ? 'b' : 'a',
          pts: arc(50, 52, r, side - span / 2, side + span / 2, 7),
          snap: Boolean(emit),
          o,
        });
      }
    return { strokes, eyes: { x: 50, y: 52 }, pose };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(core(disc(50, 52, 15 * moodK(m, t))));
    return f;
  },
};
